import * as React from "react";
import { useState } from "react";

import { SupportedMediaType } from "../../../apollo/graphql.generated";
import ImageUploader from "../ImageUploader";
import { PublicUserProfileQuery } from "../queries/profile.graphql.generated";

export interface Props {
  profile?: PublicUserProfileQuery["getPublicAccountSettings"];
  avatarUrl: string;
  avatarUrlError: string;
  onChangeAvatarUrl: (media: { url: string; type: string } | null) => void;
}

export const ProfileImageInput = ({
  profile,
  onChangeAvatarUrl,
  avatarUrl,
  avatarUrlError,
}: Props) => {
  const [editedAvatar, setEditedAvatar] = useState(!!profile?.avatarUrl);

  return (
    <ImageUploader
      mediaUrl={avatarUrl}
      mediaType={SupportedMediaType.IMAGE}
      onMediaChanged={(media) => {
        setEditedAvatar(true);
        onChangeAvatarUrl(media);
      }}
      mediaError={avatarUrlError}
      edited={editedAvatar}
    />
  );
};
